import { ArrowRight, Phone } from "lucide-react";
import { PHONE_DISPLAY, TEL_HREF } from "../../lib/contact";

const HeroArt = () => (
  <div className="gr relative mx-auto w-[240px] md:w-[340px]" style={{ perspective: 800 }} aria-hidden="true">
    <svg viewBox="0 0 300 300" className="w-full" style={{ transform: "rotateY(-14deg) rotateX(6deg)" }}>
      <g className="turn">
        <circle cx="150" cy="150" r="140" fill="none" className="stroke-sage-soft" strokeWidth="2" strokeDasharray="4 10" />
      </g>
      <path pathLength="1" className="draw fill-sand stroke-navy" d="M40 160 L150 60 L260 160 V270 H40 Z" strokeWidth="8" />
      <rect x="125" y="190" width="50" height="80" className="fill-navy" />
      <path className="fill-coral" d="M150 160c-22-14-30-26-22-36 7-8 16-4 22 4 6-8 15-12 22-4 8 10 0 22-22 36z" />
      <rect x="70" y="180" width="34" height="34" className="fill-gold" />
      <rect x="196" y="180" width="34" height="34" className="fill-gold" />
    </svg>
  </div>
);

export const Hero = () => (
  <header id="top" data-testid="hero-section" className="bg-ivory text-navy py-20 md:py-32 overflow-hidden">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1fr_300px] lg:grid-cols-[1fr_340px] gap-12 items-center">
      <div className="min-w-0">
        <p className="fu sub text-base uppercase tracking-[.14em] font-semibold text-sage mb-6">
          Eltartási és életjáradéki szerződés
        </p>
        <h1
          data-testid="hero-headline"
          className="disp uppercase"
          style={{ fontSize: "clamp(40px,5.5vw,84px)", lineHeight: 1, letterSpacing: "-0.03em" }}
        >
          <span className="ln"><span>Méltóságteljes Időskor,</span></span>
          <span className="ln"><span>Gondoskodás És Teljes Biztonság</span></span>
          <span className="ln"><span className="text-burgundy">Saját Otthonában</span></span>
        </h1>
        <p data-testid="hero-subheadline" className="fu sub mt-8 max-w-[38rem] text-xl">
          Személyre szabott eltartási és életjáradéki gondoskodás magánszemélytől. Meleg étkezés, rendszeres segítség és szigorú ügyvédi garanciák.
        </p>
        <div className="fu ctl mt-10 flex flex-wrap gap-4">
          <a
            href="#contact"
            data-testid="hero-consult-button"
            className="group bg-coral text-coral-ink px-7 py-4 text-lg font-semibold inline-flex items-center gap-3 transition-colors hover:bg-coral-deep"
          >
            Díjmentes &amp; Bizalmas Tanácsadás
            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </a>
          <a
            href={TEL_HREF}
            data-testid="hero-call-button"
            className="border-2 border-navy px-7 py-4 text-lg font-semibold tab inline-flex items-center gap-3 transition-colors hover:bg-navy hover:text-ivory"
          >
            <Phone className="h-5 w-5" /> Hívjon: {PHONE_DISPLAY}
          </a>
        </div>
      </div>
      <HeroArt />
    </div>
  </header>
);
